import script from "./BatchComparison.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchComparison.vue?vue&type=script&setup=true&lang=js"

import "./BatchComparison.vue?vue&type=style&index=0&id=1e9753ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9753ce"]])

export default __exports__